<template>
    <v-card v-if="user && user.trial" class="mt-4">
      <v-card-title>
        Explore Trial MBS Samples
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-card>
              <v-card-title>
                Agency RMBS
              </v-card-title>
              <v-card-text style="min-height:330px;">
                <v-list-item v-for="cusip in ptCusips.slice(0,6)" dense>
                  <v-list-item-content>
                    <v-list-item-title>
                      <a :href=" `/securities/${cusip}`" v-text="cusip"></a>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
              <v-dialog
                v-model="dialog"
                scrollable
                max-width="300px"
              >      
              <template v-slot:activator="{ on, attrs }">
                    <!--v-badge 
                     class="mr-4"
                      color="info" 
                      :content="ptCusips.length" 
                      overlap
                      bordered
                    -->
                      <v-btn outlined color="info" @click.stop="dialog = true">
                        Full sample list
                      </v-btn>
                    <!--/v-badge-->
                </template>
                      <v-card>
                        <v-card-title>
                          Agency RMBS
                          <v-spacer></v-spacer>
                          <v-btn color="info" text @click.stop="dialog = false"><v-icon>mdi-close</v-icon></v-btn>

                        </v-card-title>
                        <v-card-text>
                          
                          <v-list-item v-for="cusip in ptCusips" dense>
                            <v-list-item-content>
                              <v-list-item-title>
                                <a :href=" `/securities/${cusip}`" v-text="cusip"></a>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card-text>
                  <v-card-actions>
                    <v-btn color="info" outlined @click.stop="dialog = false">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>          
              </v-card-actions>

            </v-card>
          </v-col>

          <v-col cols="3">
            <v-card>
              <v-card-title>
                Agency CRT
              </v-card-title>
              <v-card-text style="min-height:330px;">
                  <trial-crt :limit="5" />                
              </v-card-text>
              <v-dialog
                v-model="dialog2"
                scrollable
                max-width="300px"
              >      
              <template v-slot:activator="{ on, attrs }">
                <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn outlined color="info" @click.stop="dialog = true">
                      Full sample list
                    </v-btn>
                </v-card-actions>

                </template>
                      <v-card>
                        <v-card-title>
                          Agency CRT
                          <v-spacer></v-spacer>
                          <v-btn color="info" text @click.stop="dialog2 = false"><v-icon>mdi-close</v-icon></v-btn>

                        </v-card-title>
                        <v-card-text>
                            <trial-crt />                
                        </v-card-text>
                  <v-card-actions>
                    <v-btn color="info" outlined @click.stop="dialog2 = false">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>              

            </v-card>
          </v-col>

          <v-col cols="3">
            <v-card>
              <v-card-title>
                Non-Agency RMBS
              </v-card-title>
              <v-card-text style="min-height:367px;">
                <v-list-item v-for="cusip in ['46649EAY5','02151AAY6','881561K37']" dense>
                  <v-list-item-content>
                    <v-list-item-title>
                      <a :href=" `/securities/${cusip}`" v-text="cusip"></a>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
              <v-card-actions>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card>
              <v-card-title>
                CMBS
              </v-card-title>
              <v-card-text style="min-height:367px;">
                <v-list-item v-for="cusip in ['3137FXLX4','78413MAN8','05492PAL2','38378KJH3','12433VAA1','3136B4KH0','05493EBC5']" dense>
                  <v-list-item-content>
                    <v-list-item-title>
                      <a :href=" `/securities/${cusip}`" v-text="cusip"></a>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
              <v-card-actions>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>    
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import TrialCRT from '@/components/TrialCRT.vue'

export default {
  name: 'Home',
  components: {
    'trial-crt': TrialCRT
  },
  computed: {
    ...mapState({
      loading: 'loading',
      user: 'user'
    })
  },
  data: () => ({
    dialog: false,
    dialog2: false,
    ptCusips: ['3140GQ2G0','3131Y3Q33','3140X47E0','3140K15K8','3140GNBU6','3133L6BB4','3140K0HG6','3133G7A45','3140X4YN0','3140JAKV9','3133L6A74','3132CWAP9','3140X4UF1','3140X5B28','3140X4T48','3133G6RV9','3140X43M6','3133G7EH2','3140JXSK5','3140K4SC5','3133G7K85','3140JYAH9','3140X4JA5','3140JPA88','3133G7BC6','3133G7JZ7','3140QCGP5','3133L6AV1','3133G7JR5','3140X4H90','3133G63P8','3140K0A99','3140K5U88','3140JXGV4','3133L7FY8','3140JWJU5','3131YACH1','3133G65H4','3132AEE93','3140QBFA1','3140HAJA9','3133G6DM4','3140H9SE4','3133G7DS9','3140HALA6','31329QZ61','3133G6B53','3132AEJS6','3140QB6P8','3140QBQY7','3131YDDF8','3140X5LP6','3140H9M42','3133G6BT1','3133G6Q32','3131YCU53','3140JWBB5','3140JPYX7','3140HBAL2','3140JQM42','3131YDDZ4','31418DAB8','3131Y9H48','3140QAQQ6','3140QBAS7','3140JUD92','31329QQU8','31329QE72','3140JKQ82','3132CWGX6','3140QAK25','3131YDCX0','3140JWPH7','3140QBXT0','3140QCNX0','3140J5JZ3','3140H3EF9','3140GR6E9','3140J5Z51','3140FQWD5','3138WJ4Z8','3140H6RW1','3140FU3Y2','31418CGD0','3140FNVM3','3140Q7M38','3140H7X69','3140J7R72','3140J7NW1','3132A5FV2','31329NGH5','3140HBP93','3131XLPS0','3140HLRX6','3132A5GD1','3132A5GU3','3131XVAG0','3140J9W64','3132A5AF2','3140J8DM2','31329NRK6','3140HHNN1','3140K1QN9','3140JSNL9','3140JUJG0','3140JUUY8','3140JNUP3','3140JSUM9','3140JMFJ6','3140JRZE4','3140JQE74','3140JS2A6','3140JVWD0','3140JYDV5','3140K0MT2','31334WA76','3132AEKS4','3140X4JY3','31346YPP2','3140JPQH1','3140QB2S6','31339UEB2','3131YBK23','3131YBK31','3131YCRA6','3132DMAR6','31339SPT6','3140JGJB2','3140JJB32','3140JJSQ3','3140JHRP0','3140JGER2','3140HLDR4','3140HLSA5','3140HBPV4','3140H4SU9','3140JHNU3','3140HMW67','3140HDJJ4','3140HMWR1','3140HMW34','3140JJHP7','3140GVPD1','3140Q7QF7','3140GRGW8','3140GNRK1','3140GQS23','3140FBPM6','3140GQPB6','3140FPCW7','3140H4C93','3140GNUT8','3140H2Z76','3140H1BD1','3140GSMB5','3140GTTJ9','3140FRDM4','3140H44C5','3140GSSC7','3140GYPW3','3140GSMX7','3140FQQR1','3140GRUW2','3140GWWU3','3140GVB53','3140GNM26','3140H1KA7','3140GNA37','3140GSC75','3140FVTG1','3140GTJH4','3140GNMQ3','3138WJ7B8','3140GQZW9','3140GQ4Q6','3140GRA53','3140FV4D5','31418CS70','3140GUMR5','3140GQK62','3138WKP66','3140FE6A7','3140Q7E37','3140GUXN2','3140GPYW2','31418CN42','3132A35F3','3140JJL23','3140HARD4','3140HBKZ0','31329PX81','3140HPSA6','31329PX73','3131XTSL5','3140HHYR0','3140HPES2','3140HBKK3','3140J8KM4','3140HA2K5','3140H8N43','31329JG50','3140HPRN9','3140JH5P4','3131Y7FA0','3140HKZZ4','3140HH3G8','31329PTD5','3131XHEN2','3131XXFG1','3131XYAL3','3131WQVK0','3140HMNG5','3140HHSS5','3140HBGY8','3140JHV91','3131WNRZ9','31418CWJ9','3140HBFW3','3140HLKP0','3140H8WP6','3131WCT73','3132A06X9','3131Y8BD6','3140JJC23','3140Q9JL8','31329PRS4','3131WF6T3','3131WNJR6','3131Y8BN4','3132A0SV9','3131WVA97','3131WUJ74','3132A0XH4','3132A0TR7','3132A0NS1','3131WYSQ4','3131X0B28','3131X0L27','3131WVB54','31329H3X7','3131WYT26','3132A3F62','3132A0Q25','3132A0LK0','3132A03S3','3132A0BJ4','3132A0J49','3131WUWH7','3132A0ST4','3131WU5C8','31329HY54','31329HHB0','3132A0NU6','3131X0SB0','31329JU70','3131WVYY6','31329HXS5','31329HM32','3132A0KT2','31329HM65','3140HB5T1','3140HBX29','3140JABW7','3140K2ZY3','31334X4K2','3133A0ET7','3140JNTR1','3140QCKX3','3140JPAZ8','3133KHAD8','3140JSLZ0','3133KGFK9','3140K2EY6','3131YCNX0','3131YAMZ0','3140JW6G0','3140JPWP6','3140JXQ68','3140K6C45','3140JALZ9','3140JM5H1','3140H9N90','3131YCNJ1','3140GNZB2','3140QAV49','31339SN92','3133A0AA2','3140JUYB4','3140X4ZW9','3140JSV55','3140K2U36','3140JUPF5','3140JAT24','3131YBM54','3131YBYR3','31334WWU1','3131YBZH4','3132DV4C6','31329P6D0','3131YAJX9','3140JLZ31','3140JNBZ2','3131YAXJ4','3140JQTR4','3140H9SD6','3140JMZB1','3131Y8UF0','3140JXXA1','3133KGDD7','3140J94J7','3131YAKH2','3140JWB90','31334YEV5','3140JQZ97','3140JMQE5','31334XEA3','3140JUGB4','3140QAXN5','3140JV6S6','3140JLV92','3140GW2C6','3140FRXJ9','3140GWBH5','3140FRX83','3140GR5X8','3140GYZK8','3140FV3V6','3140GW3U5','3140GSJL7','3140GNCY7','3140FSCP6','3140GTGB0','3140FSE33','3140GXKA8','3140GYGU7','3140GR3Q5','3140FSCR2','3140FSE58','3140GR4K7','3140GNDS9','3140GNEA7','3140GPY51','3140GNCF8','3140GR4R2','3140H3N44','3140GR4J0','31339UT42','3140K4JW1','3140JWWT3','3140JV5P3','3140JXVR6','31339SNV3','3140K2GL2','3140K5H91','3140K1KL9','3140K1QP4','3140K1KT2','31339SZH1','3140GNEF6','3140GW4V2'],
  })

}
</script>
